/*
 * Craftlabel Paket Oluşturucu: etkileşim katmanı (snippets/craftlabel-custom-pack.liquid).
 *
 * - Paket adetleri (3 / 5 / 7 / 10), fiyatlar ve kampanyalar kök elementteki
 *   <script data-cl-pack-config> JSON'undan gelir (kaynak: craftlabel-pack-prices.liquid).
 * - Tüm para hesapları kuruş cinsinden, tam sayıyla yapılır. Birim fiyat yalnızca gösterim için
 *   yuvarlanır; paket toplamı hiçbir zaman yuvarlanmış birim fiyattan yeniden hesaplanmaz.
 * - Renk, beden, stok ve varyant eşleştirme mantığı önceki sürümle aynıdır.
 * - Sepet/kapıda ödeme: paket tek bir istekle sepete eklenir. "Kapıda ödeme" paket modunda önce paketi
 *   sepete ekler, sonra temadaki CraftlabelOpenCODForm ile Releasit'i SEPET modunda açar (sepetteki
 *   tüm renk, beden ve adetleri taşır). Bu bileşen indirim UYGULAMAZ ve fiyat taklit etmez.
 * - Animasyonlar kuyruğa alınmaz: her güncelleme önceki animasyonu iptal eder ve son duruma geçer.
 *   Gerçek durum (fiyat, seçim, buton) animasyondan bağımsız ve anında güncellenir.
 */
(function () {
  'use strict';

  /* ────────────────────────── Saf yardımcılar (test edilebilir) ────────────────────────── */

  const NBSP = ' ';

  /* "5 üründen 2'sini seçtin" için sayıya göre iyelik+belirtme eki */
  const ACCUSATIVE_SUFFIX = {
    1: "'ini",
    2: "'sini",
    3: "'ünü",
    4: "'ünü",
    5: "'ini",
    6: "'sını",
    7: "'sini",
    8: "'ini",
    9: "'unu",
    10: "'unu"
  };

  /* Kuruş -> Türkçe sayı: 330000 -> "3.300", 86333 -> "863,33", 66000 -> "660" */
  function formatKurus(kurus, forceDecimals) {
    const value = Math.round(Number(kurus) || 0);
    const negative = value < 0;
    const absolute = Math.abs(value);
    const lira = Math.floor(absolute / 100);
    const remainder = absolute % 100;

    let text = String(lira).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (remainder > 0 || forceDecimals) {
      text += ',' + String(remainder).padStart(2, '0');
    }
    return (negative ? '-' : '') + text;
  }

  function formatTL(kurus, forceDecimals) {
    return formatKurus(kurus, forceDecimals) + NBSP + 'TL';
  }

  /* Binde bir hassasiyetle yüzde: 200 -> "20", 67 -> "6,7" */
  function formatPercentTenths(tenths) {
    const whole = Math.floor(tenths / 10);
    const fraction = tenths % 10;
    return fraction ? whole + ',' + fraction : String(whole);
  }

  /*
   * Bir paketin hesapları (tüm tutarlar kuruş):
   *  regular = tekli fiyat x adet        (tek tek alım toplamı)
   *  saving  = regular - paket toplamı   (toplam avantaj)
   *  unit    = paket toplamı / adet      (yalnızca gösterim için, en yakın kuruşa yuvarlanır)
   */
  function packMath(single, pack) {
    const count = pack.count;
    const total = pack.total;
    const regular = single * count;
    const saving = regular - total;
    const unit = Math.floor((Math.floor((total * 100) / count) + 50) / 100);

    return {
      count: count,
      total: total,
      regular: regular,
      saving: saving,
      unit: unit,
      unitExact: total % count === 0,
      percentTenths: regular > 0 ? Math.round((saving * 1000) / regular) : 0
    };
  }

  function progressText(selected, total) {
    return selected + '/' + total;
  }

  function sortedPacks(packs) {
    return packs.slice().sort(function (a, b) {
      return a.count - b.count;
    });
  }

  /* Yalnızca bir sonraki (bir üst) paket önerilir; en büyük pakette öneri yok. */
  function upsellFor(packs, count, noun) {
    const ordered = sortedPacks(packs);
    const current = ordered.find(function (pack) {
      return pack.count === count;
    });
    const next = ordered.find(function (pack) {
      return pack.count > count;
    });
    if (!current || !next) return null;

    const difference = next.total - current.total;
    const extra = next.count - current.count;
    if (difference <= 0 || extra <= 0) return null;

    return {
      next: next,
      difference: difference,
      extra: extra,
      lead: formatTL(difference) + ' farkla ' + extra + ' ' + (noun || 'ürün') + ' daha al',
      action: next.short + ' pakete geç'
    };
  }

  /* Sepet cevabındaki satırlardan gerçekte ödenecek tutarı paket fiyatıyla karşılaştırır. */
  function checkCartPricing(lines, packTotal) {
    if (!Array.isArray(lines) || !lines.length) return { state: 'unknown' };

    const paid = lines.reduce(function (sum, line) {
      return sum + Number(line.final_line_price || 0);
    }, 0);
    const tolerance = Math.max(lines.length, 2); // satırlara dağıtılan indirimde kuruş yuvarlaması

    if (Math.abs(paid - packTotal) <= tolerance) return { state: 'ok', paid: paid };
    return { state: paid > packTotal ? 'higher' : 'lower', paid: paid };
  }

  const Pure = {
    formatKurus: formatKurus,
    formatTL: formatTL,
    formatPercentTenths: formatPercentTenths,
    packMath: packMath,
    progressText: progressText,
    upsellFor: upsellFor,
    checkCartPricing: checkCartPricing,
    ACCUSATIVE_SUFFIX: ACCUSATIVE_SUFFIX
  };

  if (typeof module === 'object' && module.exports) {
    module.exports = { Pure: Pure };
  }

  /* Kapıda ödeme düğmesi tespiti (Releasit uygulama kodu görülemediği için metin + bilinen sınıf adları). */
  const COD_TEXT = /kapıda\s*öde|kapida\s*ode|cash\s*on\s*delivery/;
  /*
   * Temanın sabit satın alma çubukları. DİKKAT: [class*="sticky"] KULLANILMAZ: <body> "sticky-atc-bar-enabled"
   * sınıfını taşıdığı için o seçici sayfadaki HER öğeye uyardı (öneri kartlarındaki "Sepete ekle" düğmeleri dahil).
   */
  const STICKY_BAR =
    '.sticky-atc-bar, sticky-atc-bar, .cl-custom-sticky-atc, [id^="CLStickyATC"]';
  const RSI_BUTTON = '[class*="_rsi-buy-now"], [id*="_rsi-buy-now"], [data-rsi-buy-now]';
  /* Sepet çekmecesi/sayfası kendi (sepet modundaki) akışını yürütür; buralara dokunulmaz. */
  const CART_UI =
    'cart-drawer, #CartDrawer, [data-cart-drawer], [data-cl-cart-root], [data-cl-cod], [id*="CLCart"], ' +
    '[class*="cl-cart"], [data-upcart], [id*="upcart" i], [class*="upcart" i], ._rsi-buy-now-button-cart';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  /* Aynı sayfada script ikinci kez yüklenirse yalnızca tarama yap. */
  if (window.CraftlabelPack && window.CraftlabelPack.loaded) {
    window.CraftlabelPack.scan(document);
    return;
  }

  /* ────────────────────────── Bileşen ────────────────────────── */

  const instanceRegistry = (window.__craftlabelCustomPackInstances = window.__craftlabelCustomPackInstances || {});
  const reducedMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function prefersReducedMotion() {
    return Boolean(reducedMotionQuery && reducedMotionQuery.matches);
  }

  const CHECK_SVG =
    '<svg viewBox="0 0 16 16" width="10" height="10" focusable="false" aria-hidden="true"><path d="M3.2 8.4l3 3 6.6-6.8" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function initCraftlabelCustomPack(root) {
    if (!root || root.dataset.initialized === 'true') return;

    const previousCleanup = instanceRegistry[root.id];
    if (typeof previousCleanup === 'function') previousCleanup();

    const configNode = root.querySelector('[data-cl-pack-config]');
    const productDataNode = root.querySelector('[data-cl-pack-product-json]');
    if (!configNode || !productDataNode) return;

    let config;
    let localRawData;
    try {
      config = JSON.parse(configNode.textContent);
      localRawData = JSON.parse(productDataNode.textContent);
    } catch (error) {
      console.error('Craftlabel paket verisi okunamadı:', error);
      return;
    }

    root.dataset.initialized = 'true';

    const packs = sortedPacks(config.packs || []);
    const single = Number(config.single) || 0;
    const moneyVisible = (config.priceState === 'ok' || config.priceState === 'preview-mismatch') && single > 0;
    const cod = Object.assign({ show: false, route: true, label: 'Kapıda ödeme ile al' }, config.cod || {});
    const barConfig = Object.assign({ enabled: true }, config.bar || {});

    /* ───── Ürün/renk/varyant verisi (önceki sürümle aynı mantık) ───── */

    const normalizeText = value => String(value || '').trim().toLocaleLowerCase('tr-TR');

    const normalizePath = rawUrl => {
      try {
        return new URL(rawUrl, window.location.origin).pathname.replace(/\.js$/i, '').replace(/\/$/, '');
      } catch (error) {
        return '';
      }
    };

    const imageUrl = value => {
      if (!value) return '';
      if (typeof value === 'string') return value;
      if (typeof value === 'object') return value.src || value.url || '';
      return '';
    };

    function normalizeProductData(raw, fallbackUrl, meta) {
      const optionNames = Array.isArray(raw.options)
        ? raw.options.map(option => (typeof option === 'string' ? option : (option && option.name) || ''))
        : [];

      const featuredImage =
        imageUrl(raw.featuredImage) ||
        imageUrl(raw.featured_image) ||
        imageUrl(Array.isArray(raw.images) ? raw.images[0] : '') ||
        '';

      const variants = Array.isArray(raw.variants)
        ? raw.variants.map(variant => {
            const options = Array.isArray(variant.options)
              ? variant.options
              : [variant.option1, variant.option2, variant.option3].filter(
                  value => value !== null && value !== undefined
                );

            return {
              id: Number(variant.id),
              available: variant.available !== false,
              title: variant.title || '',
              price: Number(variant.price),
              options,
              image: config.key === 'jogger-pantolon' ? featuredImage : (imageUrl(variant.image) || imageUrl(variant.featured_image) || featuredImage)
            };
          })
        : [];

      const url = fallbackUrl || raw.url || localRawData.url || window.location.pathname;

      return {
        title: raw.title || localRawData.title || '',
        handle: raw.handle || '',
        url,
        path: normalizePath(url),
        featuredImage,
        optionNames,
        variants,
        colorLabel: meta && meta.label ? meta.label : '',
        swatchColor: meta && meta.swatchColor ? meta.swatchColor : '',
        swatchImage: meta && meta.swatchImage ? meta.swatchImage : ''
      };
    }

    const currentProduct = normalizeProductData(localRawData, localRawData.url || window.location.pathname, null);
    const currentPath = currentProduct.path || normalizePath(window.location.pathname);

    const sectionRoot =
      document.getElementById('MainProduct-' + root.dataset.sectionId) || root.closest('product-info') || document;

    const cardsWrap = root.querySelector('[data-cl-pack-cards]');
    const singleNote = root.querySelector('[data-cl-pack-single-note]');
    const singlePrice = root.querySelector('[data-cl-single-price]');
    const slotsWrap = root.querySelector('[data-cl-pack-slots]');
    const progressLabel = root.querySelector('[data-cl-pack-progress-text]');
    const progressBar = root.querySelector('[data-cl-pack-progress]');
    const progressFill = root.querySelector('[data-cl-pack-progress-fill]');
    const doneMark = root.querySelector('[data-cl-pack-done]');
    const hint = root.querySelector('[data-cl-pack-hint]');
    const upsellWrap = root.querySelector('[data-cl-pack-upsell-wrap]');
    const upsellButton = root.querySelector('[data-cl-pack-upsell]');
    const totalValue = root.querySelector('[data-cl-pack-total-value]');
    const unitValue = root.querySelector('[data-cl-pack-unit]');
    const savingValue = root.querySelector('[data-cl-pack-saving]');
    const regularValue = root.querySelector('[data-cl-pack-regular]');
    const campaignLine = root.querySelector('[data-cl-pack-campaign]');
    const note = root.querySelector('[data-cl-pack-note]');
    const addButton = root.querySelector('[data-cl-pack-add]');
    const addButtonText = root.querySelector('[data-cl-pack-add-text]');
    const singleLink = root.querySelector('[data-cl-pack-single]');
    const codButton = root.querySelector('[data-cl-pack-cod]');
    const bar = root.querySelector('[data-cl-pack-bar]');
    const barName = bar && bar.querySelector('[data-cl-bar-name]');
    const barTotal = bar && bar.querySelector('[data-cl-bar-total]');
    const barExtra = bar && bar.querySelector('[data-cl-bar-extra]');
    const barAdd = bar && bar.querySelector('[data-cl-bar-add]');
    const barAddLong = bar && bar.querySelector('[data-cl-bar-add-long]');
    const barAddShort = bar && bar.querySelector('[data-cl-bar-add-short]');
    const barCod = bar && bar.querySelector('[data-cl-bar-cod]');
    const modal = root.querySelector('[data-cl-pack-modal]');
    const modalTitle = modal.querySelector('[data-cl-pack-modal-title]');
    const preview = modal.querySelector('[data-cl-pack-preview]');
    const sizesWrap = modal.querySelector('[data-cl-pack-sizes]');
    const colorsWrap = modal.querySelector('[data-cl-pack-colors]');
    const sizeGroup = modal.querySelector('[data-cl-pack-size-group]');
    const colorGroup = modal.querySelector('[data-cl-pack-color-group]');
    const sizeValue = modal.querySelector('[data-cl-pack-size-value]');
    const colorValue = modal.querySelector('[data-cl-pack-color-value]');
    const colorLoading = modal.querySelector('[data-cl-pack-color-loading]');
    const warning = modal.querySelector('[data-cl-pack-warning]');
    const saveButton = modal.querySelector('[data-cl-pack-save]');
    const applyButton = modal.querySelector('[data-cl-pack-apply]');
    const removeButton = modal.querySelector('[data-cl-pack-remove]');

    /* Tema animasyonundaki transform modalı ürün kolonuna hapsedebildiği için body içine taşı. */
    document.querySelectorAll('[data-cl-pack-modal-owner="' + root.id + '"]').forEach(existing => {
      if (existing !== modal && existing.parentNode === document.body) existing.remove();
    });
    document.body.appendChild(modal);

    /* Paket çubuğu da aynı nedenle body'ye taşınır (tema animasyonu transform'u konumlamayı bozabilir). */
    document.querySelectorAll('[data-cl-pack-bar-owner="' + root.id + '"]').forEach(existing => {
      if (existing !== bar && existing.parentNode === document.body) existing.remove();
    });
    if (bar) {
      if (barConfig.enabled) document.body.appendChild(bar);
      else bar.remove();
    }

    const labels = {
      add: (config.labels && config.labels.add) || 'Paketi sepete ekle',
      hint: (config.labels && config.labels.hint) || 'Her kutuya dokunarak renk ve beden seç.',
      ready: (config.labels && config.labels.ready) || 'Paketin hazır.',
      adding: 'Sepete ekleniyor…',
      added: 'Sepete eklendi',
      addedMessage: 'Paket sepete eklendi.'
    };

    /* ───── Durum ───── */

    const validCounts = packs.map(pack => pack.count);
    const stash = window.__craftlabelPackStash;
    const stashUsable = stash && stash.key === config.key;

    /* count: 0 = tekli satın alma (paket seçili değil) */
    let count = 0;
    let slots = [];
    let parkedSlots = [];

    // const stashedCount = stashUsable ? Number(stash.count) : NaN;
    // const legacyCount = Number(window.__craftlabelSelectedPackCount);
    // const defaultCount = Number(config.defaultPack);

    // if (stashedCount === 0 || validCounts.includes(stashedCount)) {
    //   count = stashedCount;
    // } else if (validCounts.includes(legacyCount)) {
    //   count = legacyCount;
    // } else if (validCounts.includes(defaultCount)) {
    //   count = defaultCount;
    // } else {
    //   count = validCounts[0] || 0;
    // }
    const stashedCount = stashUsable ? Number(stash.count) : NaN;

    if (stashedCount === 0 || validCounts.includes(stashedCount)) {
  count = stashedCount;
  } else {
  count = 0;
  }

    const stashedSlots = stashUsable && Array.isArray(stash.slots) ? stash.slots : [];

    let undoState = null;
    let loading = false;
    let codLoading = false;
    let inlineCtaVisible = false;
    let barObserver = null;
    let lastAdded = null;
    let addedTimer = 0;
    let isAddedFlash = false;
    let activeSlotIndex = -1;
    let draftChoiceKey = '';
    let draftSize = null;
    let draftVariant = null;
    let lastFocusedElement = null;
    let productEntries = [currentProduct];
    let colorChoices = [];
    let colorsAreLoading = true;
    let pricingNote = '';

    const COLOR_NAMES = [
      'Kırık Beyaz', 'Mint Yeşili', 'Açık Kahverengi', 'Koyu Kahverengi',
      'Açık Gri', 'Koyu Gri', 'Açık Mavi', 'Koyu Mavi', 'Açık Yeşil', 'Koyu Yeşil',
      'Lacivert', 'Antrasit', 'Kahverengi', 'Bordo', 'Kırmızı', 'Siyah', 'Beyaz',
      'Gri', 'Haki', 'Bej', 'Ekru', 'Mint', 'Yeşil', 'Mavi', 'Taş', 'Vizon',
      'Füme', 'Turuncu', 'Sarı', 'Pembe', 'Mor', 'Black', 'White', 'Navy Blue',
      'Navy', 'Anthracite', 'Brown', 'Grey', 'Gray', 'Khaki', 'Beige', 'Ecru',
      'Green', 'Blue', 'Red'
    ];

    function latinize(value) {
      return normalizeText(value)
        .replace(/ı/g, 'i')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c');
    }

    function escapeRegExp(value) {
      return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function inferColorName(value) {
      const source = latinize(String(value || '').replace(/[-_]+/g, ' '));
      const sorted = COLOR_NAMES.slice().sort((a, b) => b.length - a.length);

      for (const name of sorted) {
        const normalizedName = latinize(name);
        const expression = new RegExp('(^|\\s)' + escapeRegExp(normalizedName) + '(\\s|$)');
        if (expression.test(source)) return name;
      }

      return '';
    }

    function cleanedCandidateLabel(value) {
      const raw = String(value || '')
        .replace(/^(renk|color|colour)\s*[:\-]?\s*/i, '')
        .replace(/\s+/g, ' ')
        .trim();

      return inferColorName(raw) || (raw.length > 0 && raw.length <= 28 ? raw : '');
    }

    function swatchColor(value) {
      const key = latinize(value);
      const map = {
        'siyah': '#111111', 'black': '#111111',
        'beyaz': '#ffffff', 'white': '#ffffff', 'kirik beyaz': '#eee9df',
        'lacivert': '#151a44', 'navy': '#151a44', 'navy blue': '#151a44',
        'gri': '#8d8f90', 'gray': '#8d8f90', 'grey': '#8d8f90',
        'acik gri': '#b7b8b8', 'koyu gri': '#57595a',
        'antrasit': '#3e4142', 'anthracite': '#3e4142',
        'kahverengi': '#684c3f', 'brown': '#684c3f',
        'acik kahverengi': '#9a725b', 'koyu kahverengi': '#4d352c',
        'bej': '#d9cbb7', 'beige': '#d9cbb7',
        'ekru': '#e7dfd1', 'ecru': '#e7dfd1',
        'haki': '#73765e', 'khaki': '#73765e',
        'yesil': '#68765c', 'green': '#68765c',
        'kirmizi': '#9d0000', 'red': '#9d0000', 'bordo': '#6d1724',
        'mavi': '#557da4', 'blue': '#557da4',
        'mint': '#9ee7cc', 'mint yesili': '#9ee7cc',
        'tas': '#b9b09f', 'vizon': '#a58f7c', 'fume': '#55595d',
        'turuncu': '#d46c28', 'sari': '#e8c238', 'pembe': '#d98da4', 'mor': '#76608c'
      };
      return map[key] || '#c9c9c9';
    }

    function getColorOptionIndex(productEntry) {
      return productEntry.optionNames.findIndex((name, index) => {
        if (!/renk|color|colour/i.test(String(name))) return false;
        const values = uniqueValues(productEntry, index);
        const sizeOnly = productEntry.optionNames.length === 1 && values.length > 0 &&
          values.every(value => /^(?:XXS|XS|S|M|L|XL|XXL|XXXL|[2-9]XL|10XL)$/i.test(String(value).trim()));
        return !sizeOnly;
      });
    }

    function getSizeOptionIndex(productEntry) {
      const index = productEntry.optionNames.findIndex(name => /beden|size/i.test(String(name)));
      if (index >= 0) return index;

      if (productEntry.optionNames.length === 1 && getColorOptionIndex(productEntry) < 0) return 0;
      if (productEntry.optionNames.length > 1) {
        const colorIndex = getColorOptionIndex(productEntry);
        return colorIndex === 0 ? 1 : 0;
      }
      return -1;
    }

    function uniqueValues(productEntry, optionIndex) {
      if (optionIndex < 0) return [];
      return [
        ...new Set(
          productEntry.variants
            .map(variant => variant.options[optionIndex])
            .filter(value => value !== null && value !== undefined && value !== '')
        )
      ];
    }

    function extractCandidateUrl(element) {
      const values = [
        element.getAttribute('href'),
        element.getAttribute('data-product-url'),
        element.getAttribute('data-url'),
        element.getAttribute('data-href'),
        element.getAttribute('data-product-href'),
        element.getAttribute('onclick')
      ].filter(Boolean);

      for (const value of values) {
        const productMatch = String(value).match(
          /(?:https?:\/\/[^\s'"]+)?(?:\/[^\s'"]*)?\/products\/[^?\s'"#)]+/i
        );
        if (productMatch) return productMatch[0];
      }
      return '';
    }

    function extractCandidateLabel(element) {
      /* Temadaki renk seçici etiketi (ör. "Taş Rengi") doğrudan ve birebir kullanılır. */
      const named = String(element.getAttribute('data-color-name') || '').trim();
      if (named) return named;

      const values = [
        element.getAttribute('data-value'),
        element.getAttribute('data-color'),
        element.getAttribute('data-option-value'),
        element.getAttribute('aria-label'),
        element.getAttribute('title'),
        element.querySelector('img') && element.querySelector('img').getAttribute('alt'),
        element.textContent
      ].filter(Boolean);

      for (const value of values) {
        const cleaned = cleanedCandidateLabel(value);
        if (cleaned) return cleaned;
      }
      return '';
    }

    function extractCandidateSwatch(element) {
      const swatch = element.querySelector('.inner-circle, .swatch-color, [data-swatch]');
      const nodes = swatch ? [swatch] : [element, ...element.querySelectorAll('*')];

      for (const node of nodes) {
        const style = window.getComputedStyle(node);
        const backgroundImage = style.backgroundImage;
        const backgroundColor = node.style.backgroundColor || style.backgroundColor;

        if (backgroundImage && backgroundImage !== 'none') {
          return { swatchImage: backgroundImage, swatchColor: '' };
        }

        if (
          backgroundColor &&
          !/rgba?\(0,\s*0,\s*0,\s*0\)/.test(backgroundColor) &&
          backgroundColor !== 'transparent'
        ) {
          return { swatchImage: '', swatchColor: backgroundColor };
        }
      }

      return { swatchImage: '', swatchColor: '' };
    }

    function looksLikeColorSwatch(element) {
      const parent = element.closest(
        'fieldset, [class*="swatch"], [class*="color"], [class*="colour"], [class*="renk"], [data-option-name], [data-option-index], .product-form__input, .product__block--variant_picker'
      );

      const context = [
        element.className,
        element.id,
        parent && parent.className,
        parent && parent.getAttribute('data-option-name'),
        parent && parent.textContent && parent.textContent.slice(0, 80)
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      if (/swatch|color|colour|renk/.test(context)) return true;

      const rectangle = element.getBoundingClientRect();
      return Boolean(
        parent && rectangle.width > 0 && rectangle.height > 0 && rectangle.width <= 90 && rectangle.height <= 90
      );
    }

    function collectColorProductCandidates() {
      const selector = [
        'a[href*="/products/"]',
        '[data-product-url*="/products/"]',
        '[data-url*="/products/"]',
        '[data-href*="/products/"]',
        '[data-product-href*="/products/"]'
      ].join(',');

      const candidates = [];
      const seen = new Set();
      const colorPicker = sectionRoot.querySelector('[data-cl-color-picker]');
      const candidateRoot = colorPicker || sectionRoot;

      candidateRoot.querySelectorAll(selector).forEach(element => {
        if (!looksLikeColorSwatch(element)) return;

        const rawUrl = extractCandidateUrl(element);
        const path = normalizePath(rawUrl);
        if (!path || !/\/products\//i.test(path) || seen.has(path)) return;

        seen.add(path);
        const visual = extractCandidateSwatch(element);
        candidates.push({
          url: rawUrl,
          path,
          named: Boolean(String(element.getAttribute('data-color-name') || '').trim()),
          label: extractCandidateLabel(element),
          swatchColor: visual.swatchColor,
          swatchImage: visual.swatchImage
        });
      });

      return candidates;
    }

    async function fetchProductEntry(candidate) {
      try {
        /*
         * Temadaki bazı renk bağlantıları mutlak adres taşır (ör. https://www.craftlabel.store/products/...).
         * Taslak tema önizlemesi veya farklı alan adı için istek her zaman sayfanın KENDİ alan adına gider.
         */
        const parsed = new URL(candidate.url, window.location.origin);
        const url = new URL(window.location.origin);
        url.pathname = parsed.pathname.replace(/\.js$/i, '').replace(/\/$/, '') + '.js';

        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) throw new Error('HTTP ' + response.status);
        const raw = await response.json();
        const entry = normalizeProductData(raw, candidate.url, candidate);

        if (!entry.colorLabel) {
          entry.colorLabel = inferColorName(entry.title) || inferColorName(entry.handle) || entry.title;
        }

        return entry;
      } catch (error) {
        console.warn('Craftlabel renk ürünü yüklenemedi:', candidate.url, error);
        return null;
      }
    }

    function buildColorChoices() {
      const nextChoices = [];
      const seen = new Set();

      productEntries.forEach(productEntry => {
        const colorIndex = getColorOptionIndex(productEntry);
        const sizeIndex = getSizeOptionIndex(productEntry);

        if (colorIndex >= 0) {
          uniqueValues(productEntry, colorIndex).forEach(colorName => {
            const key = productEntry.path + '::' + colorName;
            if (seen.has(key)) return;
            seen.add(key);

            nextChoices.push({
              key,
              label: colorName,
              product: productEntry,
              colorValue: colorName,
              colorIndex,
              sizeIndex,
              swatchColor: productEntry.swatchColor || swatchColor(colorName),
              swatchImage: productEntry.swatchImage || '',
              isCurrent: productEntry.path === currentPath
            });
          });
        } else {
          const label =
            productEntry.colorLabel ||
            inferColorName(productEntry.title) ||
            inferColorName(productEntry.handle) ||
            'Seçili Renk';
          const key = productEntry.path + '::__product__';
          if (seen.has(key)) return;
          seen.add(key);

          nextChoices.push({
            key,
            label,
            product: productEntry,
            colorValue: null,
            colorIndex: -1,
            sizeIndex,
            swatchColor: productEntry.swatchColor || swatchColor(label),
            swatchImage: productEntry.swatchImage || '',
            isCurrent: productEntry.path === currentPath
          });
        }
      });

      colorChoices = nextChoices;

      if (!draftChoiceKey || !colorChoices.some(choice => choice.key === draftChoiceKey)) {
        const preferred = colorChoices.find(choice => choice.isCurrent) || colorChoices[0];
        draftChoiceKey = preferred ? preferred.key : '';
      }
    }

    function choiceByKey(key) {
      return colorChoices.find(choice => choice.key === key) || null;
    }

    function choiceSizes(choice) {
      if (!choice || choice.sizeIndex < 0) return [];
      return uniqueValues(choice.product, choice.sizeIndex);
    }

    /* Stok kontrolü: yalnızca available olan varyant seçilebilir. */
    function variantMatchesChoice(variant, choice, size) {
      if (!variant || !variant.available || !choice) return false;
      if (choice.colorIndex >= 0 && choice.colorValue && variant.options[choice.colorIndex] !== choice.colorValue) {
        return false;
      }
      if (choice.sizeIndex >= 0 && size && variant.options[choice.sizeIndex] !== size) return false;
      return true;
    }

    function findVariant(choice, size) {
      if (!choice) return null;
      return choice.product.variants.find(variant => variantMatchesChoice(variant, choice, size)) || null;
    }

    function isSizeAvailable(choice, size) {
      return Boolean(findVariant(choice, size));
    }

    /* Renk hiç stokta yoksa (hiçbir bedeni available değil) */
    function isChoiceSoldOut(choice) {
      return !choiceSizes(choice).some(size => isSizeAvailable(choice, size)) && !(choice.sizeIndex < 0 && findVariant(choice, null));
    }

    function imageForChoice(choice, size) {
      if (!choice) return currentProduct.featuredImage || '';
      const exact = findVariant(choice, size);
      if (exact && exact.image) return exact.image;

      const colorVariant = choice.product.variants.find(variant => {
        if (!variant.available) return false;
        if (choice.colorIndex >= 0 && choice.colorValue) {
          return variant.options[choice.colorIndex] === choice.colorValue && variant.image;
        }
        return Boolean(variant.image);
      });

      return (
        (colorVariant && colorVariant.image) ||
        choice.product.featuredImage ||
        currentProduct.featuredImage ||
        ''
      );
    }

    async function loadLinkedColorProducts() {
      const candidates = collectColorProductCandidates();
      const candidateByPath = new Map(candidates.map(candidate => [candidate.path, candidate]));
      const currentMeta = candidateByPath.get(currentPath);

      /*
       * Mevcut ürünün rengini öncelikle ürün adından al.
       * Böylece DOM'daki yanlış metinler renk adı olmaz.
       */
      const namedLabel = currentMeta && currentMeta.named ? currentMeta.label : '';
      const currentColorLabel =
        namedLabel ||
        inferColorName(currentProduct.title) ||
        inferColorName(currentProduct.handle) ||
        inferColorName(currentMeta && currentMeta.label) ||
        'Seçili Renk';

      currentProduct.colorLabel = currentColorLabel;
      currentProduct.swatchColor = (currentMeta && currentMeta.swatchColor) || swatchColor(currentColorLabel);
      currentProduct.swatchImage = (currentMeta && currentMeta.swatchImage) || '';

      buildColorChoices();
      if (!modal.hidden) renderModalOptions();

      const remoteCandidates = candidates.filter(candidate => candidate.path !== currentPath).slice(0, 30);
      const results = await Promise.all(remoteCandidates.map(fetchProductEntry));
      const remoteEntries = results.filter(Boolean);

      const entriesByPath = new Map();
      [currentProduct, ...remoteEntries].forEach(entry => {
        if (entry.path && !entriesByPath.has(entry.path)) entriesByPath.set(entry.path, entry);
      });

      productEntries = [...entriesByPath.values()];
      colorsAreLoading = false;
      buildColorChoices();

      if (!modal.hidden) {
        renderModalOptions();
        refreshModalState();
      }
    }

    /* ───── Yardımcılar: paket, animasyon ───── */

    function currentPack() {
      return packs.find(pack => pack.count === count) || null;
    }

    function filledCount() {
      return slots.slice(0, count).filter(Boolean).length;
    }

    function isComplete() {
      return count > 0 && filledCount() === count;
    }

    /*
     * Sayı geçişi: önceki animasyon iptal edilir, mevcut görünen değerden yeni hedefe gidilir.
     * Hedef değer data-kurus'a anında yazılır; metin ~300 ms içinde akar.
     */
    function tweenText(element, target, format, animate) {
      if (!element) return;

      if (element.__clpFrame) {
        window.cancelAnimationFrame(element.__clpFrame);
        element.__clpFrame = 0;
      }
      window.clearTimeout(element.__clpTimer);

      element.dataset.kurus = String(target);
      const from = element.__clpShown;

      function finish() {
        window.clearTimeout(element.__clpTimer);
        if (element.__clpFrame) window.cancelAnimationFrame(element.__clpFrame);
        element.__clpFrame = 0;
        element.textContent = format(target);
        element.__clpShown = target;
      }

      if (!animate || prefersReducedMotion() || typeof from !== 'number' || from === target) {
        finish();
        return;
      }

      const duration = 300;
      const started = window.performance.now();

      function step(now) {
        const progress = Math.min(1, (now - started) / duration);

        if (progress >= 1) {
          finish();
          return;
        }

        const eased = 1 - Math.pow(1 - progress, 3);
        /* Ara kareler tam liraya yuvarlanır (kuruş titremesi olmaz); son karede gerçek hedef yazılır. */
        const value = Math.round((from + (target - from) * eased) / 100) * 100;

        element.textContent = format(value);
        element.__clpShown = value;
        element.__clpFrame = window.requestAnimationFrame(step);
      }

      element.__clpFrame = window.requestAnimationFrame(step);

      /* Gizli/kısılmış sekmede rAF durabilir: ekrandaki değer yine de hedefe ulaşsın. */
      element.__clpTimer = window.setTimeout(finish, duration + 80);
    }

    function restartAnimation(element, className) {
      if (!element || prefersReducedMotion()) return;
      element.classList.remove(className);
      void element.offsetWidth;
      element.classList.add(className);
    }

    function setHint(kind, text, undoCallback) {
      const signature = kind + '|' + text;
      if (!undoCallback && hint.dataset.signature === signature) return;
      hint.dataset.signature = undoCallback ? '' : signature;

      hint.className = 'cl-pack__hint' + (kind ? ' is-' + kind : '');
      hint.textContent = text;

      if (undoCallback) {
        hint.append(' ');
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = 'Geri al';
        button.addEventListener('click', undoCallback);
        hint.appendChild(button);
      }
    }

    function resetHint() {
      if (isComplete()) {
        setHint('success', labels.ready);
      } else {
        setHint('', labels.hint);
      }
    }

    function setNote(text) {
      pricingNote = text || '';
      note.hidden = !pricingNote;
      note.textContent = pricingNote;
    }

    /* ───── Görünüm: kartlar, slotlar, özet ───── */

    function updateCards() {
      const cards = [...cardsWrap.querySelectorAll('.cl-pack__card[data-cl-pack-count]')];
      const hasSelection = cards.some(card => Number(card.dataset.clPackCount) === count);

      const active = currentPack();
      campaignLine.textContent = moneyVisible && active && active.campaign === '5-al-4-ode' ? '5 al 4 öde' : '';
      cards.forEach((card, index) => {
        const selected = Number(card.dataset.clPackCount) === count;
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-checked', selected ? 'true' : 'false');
        card.tabIndex = selected || (!hasSelection && index === 0) ? 0 : -1;
      });
    }

    function slotLabelFor(index, slot) {
      if (!slot) return 'Ürün ' + (index + 1) + ' için renk ve beden seç';
      return (
        'Ürün ' + (index + 1) + ': ' + [slot.colorLabel, slot.size].filter(Boolean).join(', ') + '. Seçimi değiştir'
      );
    }

    function createSlotElement(index) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cl-pack__slot';
      button.dataset.slotIndex = String(index);
      return button;
    }

    function paintSlot(button, index, slot, animate) {
      const key = slot ? String(slot.variantId) : '';
      if (button.dataset.painted === '1' && button.dataset.key === key && button.dataset.index === String(index)) {
        return;
      }

      button.dataset.painted = '1';
      button.dataset.key = key;
      button.dataset.index = String(index);
      button.dataset.slotIndex = String(index);
      button.classList.toggle('is-filled', Boolean(slot));
      button.setAttribute('aria-label', slotLabelFor(index, slot));
      button.textContent = '';

      const box = document.createElement('span');
      box.className = 'cl-pack__slot-box';
      const label = document.createElement('span');
      label.className = 'cl-pack__slot-label';

      if (slot) {
        const image = document.createElement('img');
        image.className = 'cl-pack__slot-image';
        image.src = slot.image || currentProduct.featuredImage || '';
        image.alt = [slot.colorLabel, slot.size].filter(Boolean).join(' ');
        image.decoding = 'async';

        const check = document.createElement('span');
        check.className = 'cl-pack__slot-check';
        check.setAttribute('aria-hidden', 'true');
        check.innerHTML = CHECK_SVG.replace('width="10" height="10"', 'width="9" height="9"');

        box.append(image, check);

        if (slot.size) {
          const size = document.createElement('b');
          size.textContent = slot.size;
          label.append(size);
        }
        if (slot.colorLabel) {
          const color = document.createElement('span');
          color.textContent = slot.colorLabel;
          color.title = slot.colorLabel;
          label.append(color);
        }

        if (animate && !prefersReducedMotion()) {
          button.classList.add('is-new');
          window.setTimeout(() => button.classList.remove('is-new'), 600);
        }
      } else {
        const plus = document.createElement('span');
        plus.className = 'cl-pack__slot-plus';
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        box.append(plus);
        button.classList.remove('is-new');
      }

      button.append(box, label);
    }

    /* Kutular yeniden kurulmaz; yalnızca değişen kutu güncellenir (aksi halde hepsi yeniden belirirdi). */
    function renderSlots(animateIndex) {
      slotsWrap.dataset.layout = String(count);

      const existing = [...slotsWrap.children].filter(node => node.classList.contains('cl-pack__slot'));
      existing.slice(count).forEach(node => node.remove());

      for (let index = 0; index < count; index += 1) {
        let button = existing[index];
        if (!button) {
          button = createSlotElement(index);
          slotsWrap.appendChild(button);
        }
        paintSlot(button, index, slots[index] || null, index === animateIndex);
      }
    }

    function priceDriftCount() {
      if (!moneyVisible) return 0;
      return slots.slice(0, count).filter(slot => slot && Number.isFinite(slot.price) && slot.price !== single).length;
    }

    function renderAddButton() {
      const ready = isComplete();
      const busy = isBusy();

      let addLong;
      let addShort;
      if (loading) {
        addLong = labels.adding;
        addShort = 'Ekleniyor…';
      } else if (isAddedFlash) {
        addLong = labels.added;
        addShort = 'Eklendi';
      } else if (ready) {
        addLong = 'Sepete ekle';
        addShort = 'Sepete ekle';
      } else {
        addLong = addShort = 'Renk ve beden seç';
      }

      const codLong = codLoading ? 'Kapıda ödeme açılıyor…' : cod.label;
      const codShort = codLoading ? 'Açılıyor…' : 'Kapıda ödeme';

      function paintAdd(button) {
        button.classList.toggle('is-incomplete', !ready && !loading);
        button.classList.toggle('is-loading', loading);
        button.classList.toggle('is-added', isAddedFlash && !loading);
        button.setAttribute('aria-disabled', !busy ? 'false' : 'true');
        button.setAttribute('aria-busy', loading ? 'true' : 'false');
      }

      function paintCod(button) {
        button.classList.toggle('is-incomplete', !ready && !codLoading);
        button.classList.toggle('is-loading', codLoading);
        button.setAttribute('aria-disabled', ready && !busy ? 'false' : 'true');
        button.setAttribute('aria-busy', codLoading ? 'true' : 'false');
      }

      paintAdd(addButton);
      addButtonText.textContent = addLong;

      if (codButton) {
        paintCod(codButton);
        codButton.textContent = codLong;
      }

      /* Sabit alt çubuk: aynı durum, aynı etiketler (dar ekranda kısa metin). */
      if (bar) {
        paintAdd(barAdd);
        barAddLong.textContent = addLong;
        barAddShort.textContent = addShort;

        if (barCod) {
          paintCod(barCod);
          barCod.textContent = codShort;
        }
      }
    }

    /* ───── Sabit alt paket çubuğu (paket modunda tekli çubuğun yerine geçer) ───── */

    let whatsappFrame = 0;
    function positionWhatsapp() {
      whatsappFrame = 0;
      const html = document.documentElement;
      const whatsapp = document.querySelector('.cl-wa');
      if (!whatsapp || count === 0) {
        html.style.removeProperty('--cl-pack-wa-lift');
        delete html.dataset.clPackWaHidden;
        return;
      }
      const baseBottom = html.dataset.clPackBar === 'on' && bar
        ? bar.offsetHeight + 12
        : parseFloat(getComputedStyle(html).getPropertyValue('--cl-wa-bottom')) || 85;
      const button = whatsapp.getBoundingClientRect();
      const area = root.getBoundingClientRect();
      const bottom = window.innerHeight - baseBottom;
      const overlaps = button.right > area.left && button.left < area.right &&
        bottom > area.top && bottom - button.height < area.bottom;
      html.style.setProperty('--cl-pack-wa-lift', overlaps ? Math.max(0, window.innerHeight - area.top + 12) + 'px' : '0px');
      html.dataset.clPackWaHidden = overlaps && area.top - button.height - 12 < 80 ? 'true' : 'false';
    }

    function scheduleWhatsapp() {
      if (!whatsappFrame) whatsappFrame = window.requestAnimationFrame(positionWhatsapp);
    }

    function measureBar() {
      if (bar && !bar.hidden) document.documentElement.style.setProperty('--cl-pack-bar-h', bar.offsetHeight + 'px');
      scheduleWhatsapp();
    }

    function renderBar() {
      if (!bar) return;

      const pack = currentPack();
      if (!pack) return;

      barName.textContent = pack.short + ' Paket';

      if (moneyVisible) {
        const math = packMath(single, pack);
        barTotal.hidden = false;
        barTotal.textContent = formatTL(math.total);
        barExtra.className = 'cl-pack-bar__extra cl-pack-bar__extra--saving';
        barExtra.textContent = '';
        barExtra.hidden = true;
      } else {
        barTotal.hidden = true;
        barTotal.textContent = '';
        barExtra.className = 'cl-pack-bar__extra';
        barExtra.textContent = filledCount() + '/' + count + ' seçildi';
        barExtra.hidden = false;
      }

      measureBar();
    }

    /*
     * html[data-cl-pack-bar]: off = tekli mod/kapalı (temanın kendi çubuğu görünür)
     *                         idle = paket modu ama gövdedeki düğme görünürde (çubuk gizli)
     *                         on = paket çubuğu görünür (temanın tekli çubuğu CSS ile gizlenir)
     */
    function renderBarState() {
      const root_ = document.documentElement;

      if (!bar || !barConfig.enabled || count === 0) {
        if (bar) {
          bar.classList.remove('is-visible');
          bar.hidden = true;
        }
        root_.dataset.clPackBar = 'off';
        root_.style.removeProperty('--cl-pack-bar-h');
        scheduleWhatsapp();
        return;
      }

      const show = !inlineCtaVisible && modal.hidden;
      bar.hidden = false;
      bar.classList.toggle('is-visible', show);
      root_.dataset.clPackBar = show ? 'on' : 'idle';
      measureBar();
    }

    function renderUpsell() {
      const suggestion = moneyVisible && count > 0 ? upsellFor(packs, count, config.noun) : null;
      const wasOpen = upsellWrap.classList.contains('is-open');

      if (!suggestion) {
        upsellWrap.classList.remove('is-open');
        upsellButton.dataset.target = '';
        return;
      }

      const signature = count + '>' + suggestion.next.count;
      const changed = upsellButton.dataset.signature !== signature;

      if (changed) {
        upsellButton.textContent = suggestion.extra + ' ürün daha ekle · +' + formatTL(suggestion.difference);
        upsellButton.dataset.signature = signature;
        if (wasOpen) restartAnimation(upsellButton, 'is-swap');
      }

      upsellButton.dataset.target = String(suggestion.next.count);
      upsellWrap.classList.add('is-open');
    }

    function renderMoney(animate) {
      const pack = currentPack();
      if (!moneyVisible || !pack || !totalValue) return;

      const math = packMath(single, pack);
      regularValue.textContent = math.saving > 0 ? formatTL(math.regular) : '';
      regularValue.hidden = math.saving <= 0;
      savingValue.parentElement.hidden = math.saving <= 0;

      tweenText(totalValue, math.total, value => formatTL(value), animate);
      tweenText(unitValue, math.unit, value => formatTL(value, !math.unitExact) + NBSP + '/' + NBSP + 'adet', animate);
      tweenText(
        savingValue,
        math.saving,
        value => formatTL(value) + ' kazanç',
        animate
      );
    }

    function updateSummary(options) {
      const settings = options || {};
      const completed = filledCount();
      const ready = isComplete();

      if (count > 0) {
        progressLabel.textContent = progressText(completed, count);
        progressBar.setAttribute('aria-valuemax', String(count));
        progressBar.setAttribute('aria-valuenow', String(completed));
        progressFill.style.transform = 'scaleX(' + (count ? completed / count : 0) + ')';
      }

      if (doneMark) {
        doneMark.classList.toggle('is-visible', ready);
      }

      renderMoney(Boolean(settings.animate));
      renderUpsell();
      renderAddButton();
      renderBar();

      /* Sonradan seçimi değişen paket için fiyat farkı notu */
      const drift = priceDriftCount();
      if (drift > 0) {
        setNote('Seçtiğin bazı ürünlerin tekli fiyatı fiyat listesinden farklı. Paket tutarı sepette değişebilir.');
      } else if (!settings.keepNote) {
        setNote('');
      }

      document.documentElement.dataset.clPackReady = count > 0 && ready ? 'true' : count === 0 ? 'true' : 'false';
      document.documentElement.dataset.clPackCount = String(count || 1);

    }

    function persist() {
      window.__craftlabelSelectedPackCount = count;
      window.__craftlabelPackStash = {
        key: config.key,
        count: count,
        slots: (count > 0 ? slots : parkedSlots).slice()
      };
    }

    /* ───── Tekli / paket modu (yerel satın alma düğmeleri) ───── */

    function getNativePurchaseBlocks() {
      const nativeSectionRoot =
        document.getElementById('MainProduct-' + root.dataset.sectionId) || root.closest('product-info') || document;
      return [...nativeSectionRoot.querySelectorAll('.product__block--buy_buttons')];
    }

    function syncPurchaseMode() {
      const isSingleMode = count === 0;

      root.classList.toggle('is-single', isSingleMode);
      if (singleNote) singleNote.hidden = !isSingleMode;

      getNativePurchaseBlocks().forEach(nativeBlock => {
        nativeBlock.hidden = !isSingleMode;
        if (isSingleMode) {
          nativeBlock.removeAttribute('aria-hidden');
        } else {
          nativeBlock.setAttribute('aria-hidden', 'true');
        }
      });

      if (isSingleMode && !modal.hidden) closeModal();
      syncSinglePrice();
      syncSingleQuantity();

      document.documentElement.dataset.clPackMode = isSingleMode ? 'single' : 'bundle';
      renderBarState();
    }

    function nativeSingleForms() {
      const main = document.getElementById(root.dataset.productFormId);
      const sticky = [...document.querySelectorAll(STICKY_BAR)].flatMap(element => [...element.querySelectorAll('form')]);
      return [main, ...sticky].filter(form => form && currentProduct.variants.some(variant => String(variant.id) === form.querySelector('[name="id"]')?.value));
    }

    function syncSingleQuantity() {
      if (count !== 0) return;
      nativeSingleForms().forEach(form => {
        [...form.elements].filter(input => input.name === 'quantity').forEach(input => { input.value = '1'; });
      });
    }

    function syncSinglePrice(event) {
      const candidate = event?.detail?.variant;
      const form = document.getElementById(root.dataset.productFormId);
      const id = candidate?.id || form?.querySelector('[name="id"]')?.value || singlePrice.dataset.variantId;
      const variant = currentProduct.variants.find(variant => String(variant.id) === String(id));
      if (!variant) return;
      singlePrice.dataset.variantId = String(variant.id);
      singlePrice.textContent = formatKurus(variant.price);
    }

    function handleNativeChange(event) {
      if (sectionRoot.contains(event.target) || event.target.closest?.(STICKY_BAR)) {
        syncSinglePrice();
        syncSingleQuantity();
      }
    }

    function handleSingleFormData(event) {
      if (count === 0 && nativeSingleForms().includes(event.target)) event.formData.set('quantity', '1');
    }

    function restoreNativePurchaseControls() {
      getNativePurchaseBlocks().forEach(nativeBlock => {
        nativeBlock.hidden = false;
        nativeBlock.removeAttribute('aria-hidden');
      });
    }

    /* ───── Paket değiştirme ───── */

    function setPackCount(nextCount, options) {
      const settings = options || {};
      const next = Number(nextCount);
      if (!Number.isInteger(next) || (next !== 0 && !validCounts.includes(next))) return;

      const previous = count;
      const initial = Boolean(settings.initial);
      if (!initial && next === previous) return;

      const snapshot = slots.slice();
      let removed = [];

      if (next === 0) {
        /* Tekli moda geçerken seçimler saklanır; pakete dönünce geri gelir. */
        if (previous > 0) parkedSlots = snapshot;
        slots = [];
      } else {
        const source = previous === 0 && parkedSlots.length ? parkedSlots : slots;
        removed = source.slice(next).filter(Boolean);
        slots = Array.from({ length: next }, (_, index) => source[index] || null);
        if (previous === 0) parkedSlots = [];
      }

      count = next;
      if (!initial) undoState = null;

      updateCards();
      renderSlots(-1);
      syncPurchaseMode();
      persist();
      updateSummary({ animate: !initial });

      if (initial) {
        resetHint();
        return;
      }

      if (next > 0 && removed.length) {
        /* Küçülen pakette fazla seçimler kaldırılır; bunu açıkça göster ve geri alınabilir yap. */
        undoState = { count: previous, slots: snapshot };
        const shortName = (currentPack() && currentPack().short) || next + ' adet';
        setHint(
          'info',
          shortName + ' pakete geçtin. Fazla ' + removed.length + ' seçim kaldırıldı.',
          undoPackChange
        );
      } else {
        resetHint();
      }
    }

    function undoPackChange() {
      if (!undoState) return;
      const restore = undoState;
      undoState = null;

      count = restore.count;
      slots = restore.slots.slice(0, restore.count);
      while (slots.length < restore.count) slots.push(null);

      updateCards();
      renderSlots(-1);
      syncPurchaseMode();
      persist();
      updateSummary({ animate: true });
      resetHint();
    }

    /* ───── Renk / beden penceresi ───── */

    function renderColorOptions() {
      colorsWrap.innerHTML = '';
      colorGroup.hidden = colorChoices.length === 0;
      colorLoading.hidden = !colorsAreLoading;

      colorChoices.forEach(choice => {
        const button = document.createElement('button');
        const soldOut = isChoiceSoldOut(choice);

        button.type = 'button';
        button.className = 'cl-pack-modal__color';
        button.dataset.choiceKey = choice.key;
        button.dataset.shortLabel = choice.label;
        button.title = choice.label + (soldOut ? ' (stokta yok)' : '');

        button.setAttribute('aria-label', choice.label + (soldOut ? ', stokta yok' : ''));
        button.setAttribute('aria-pressed', choice.key === draftChoiceKey ? 'true' : 'false');

        button.style.setProperty('--cl-swatch', choice.swatchColor || swatchColor(choice.label));
        if (choice.swatchImage) {
          button.style.setProperty('--cl-swatch-image', choice.swatchImage);
        } else {
          button.style.removeProperty('--cl-swatch-image');
        }
        button.classList.toggle('is-selected', choice.key === draftChoiceKey);
        button.classList.toggle('is-soldout', soldOut);

        button.addEventListener('click', () => {
          draftChoiceKey = choice.key;

          const validSizes = choiceSizes(choice);

          if (draftSize && !isSizeAvailable(choice, draftSize)) draftSize = null;

          if (!draftSize && validSizes.length === 1 && isSizeAvailable(choice, validSizes[0])) {
            draftSize = validSizes[0];
          }

          preview.src = imageForChoice(choice, draftSize);

          renderSizeOptions();
          refreshModalState();
        });

        colorsWrap.appendChild(button);
      });
    }

    function renderSizeOptions() {
      sizesWrap.innerHTML = '';
      const choice = choiceByKey(draftChoiceKey);
      const sizes = choiceSizes(choice);

      sizeGroup.hidden = !choice || choice.sizeIndex < 0;

      sizes.forEach(size => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cl-pack-modal__size';
        button.textContent = size;
        button.dataset.value = size;
        button.disabled = !isSizeAvailable(choice, size);
        button.classList.toggle('is-selected', size === draftSize);
        if (button.disabled) button.setAttribute('aria-label', size + ', stokta yok');

        button.addEventListener('click', () => {
          if (button.disabled) return;
          draftSize = size;
          preview.src = imageForChoice(choice, size);
          refreshModalState();
        });

        sizesWrap.appendChild(button);
      });
    }

    function renderModalOptions() {
      renderColorOptions();
      renderSizeOptions();
    }

    function setModalMessage(kind, text) {
      warning.className = 'cl-pack-modal__message' + (kind ? ' is-' + kind : '');
      warning.textContent = text;
    }

    function refreshModalState() {
      const choice = choiceByKey(draftChoiceKey);
      const sizes = choiceSizes(choice);

      [...colorsWrap.children].forEach(button => {
        const selected = button.dataset.choiceKey === draftChoiceKey;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      [...sizesWrap.children].forEach(button => {
        button.classList.toggle('is-selected', button.dataset.value === draftSize);
      });

      colorValue.textContent = choice ? choice.label : 'Seçiniz';
      sizeValue.textContent = draftSize || (choice && choice.sizeIndex < 0 ? 'Tek seçenek' : 'Seçiniz');

      const requiredSizeReady = Boolean(choice) && (choice.sizeIndex < 0 || Boolean(draftSize));
      draftVariant = requiredSizeReady ? findVariant(choice, draftSize) : null;
      const ready = Boolean(choice && requiredSizeReady && draftVariant);

      saveButton.disabled = !ready;
      applyButton.disabled = !ready;
      saveButton.textContent = slots[activeSlotIndex] ? 'Güncelle' : 'Pakete ekle';
      removeButton.hidden = !slots[activeSlotIndex];

      /* Eksik seçim nötr yönlendirmedir; kırmızı yalnızca gerçek stok/veri sorununda kullanılır. */
      if (colorsAreLoading) {
        setModalMessage('', '');
      } else if (!colorChoices.length) {
        setModalMessage('warning', 'Renk seçenekleri bulunamadı.');
      } else if (choice && choice.sizeIndex >= 0 && !sizes.some(size => isSizeAvailable(choice, size))) {
        setModalMessage('warning', 'Bu renk şu an stokta yok. Başka bir renk seç.');
      } else if (choice && choice.sizeIndex >= 0 && !draftSize) {
        setModalMessage('', 'Bir beden seç.');
      } else if (requiredSizeReady && !draftVariant) {
        setModalMessage('warning', 'Bu renk ve beden kombinasyonu stokta yok.');
      } else {
        setModalMessage('', '');
      }
    }

    function focusableInModal() {
      return [...modal.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')].filter(
        element => !element.hidden && element.offsetParent !== null
      );
    }

    function openModal(index) {
      activeSlotIndex = index;
      lastFocusedElement = document.activeElement;

      const existing = slots[index];
      const defaultChoice = colorChoices.find(choice => choice.isCurrent) || colorChoices[0] || null;

      draftChoiceKey = existing ? existing.choiceKey : defaultChoice ? defaultChoice.key : '';
      draftSize = existing ? existing.size : null;
      draftVariant = existing ? existing.variant : null;

      const choice = choiceByKey(draftChoiceKey);
      const sizes = choiceSizes(choice);
      if (!draftSize && sizes.length === 1 && isSizeAvailable(choice, sizes[0])) draftSize = sizes[0];

      slotsWrap.querySelector('[data-slot-index="' + index + '"]').scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
      modalTitle.textContent = (index + 1) + '/' + count + ' · Renk ve beden seç';
      preview.src = existing && existing.image ? existing.image : imageForChoice(choice, draftSize);

      renderModalOptions();
      refreshModalState();

      modal.hidden = false;
      document.body.classList.add('cl-pack-modal-open');
      renderBarState();
      window.requestAnimationFrame(() => {
        const close = modal.querySelector('.cl-pack-modal__close');
        if (close) close.focus();
      });
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('cl-pack-modal-open');
      renderBarState();
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function' && lastFocusedElement.isConnected) {
        lastFocusedElement.focus({ preventScroll: true });
      }
    }

    function saveSlot(applyAll = false) {
      const choice = choiceByKey(draftChoiceKey);
      if (!choice || !draftVariant || activeSlotIndex < 0 || activeSlotIndex >= count) return;

      const index = activeSlotIndex;
      const wasComplete = isComplete();
      slots[index] = {
        variantId: Number(draftVariant.id),
        variant: draftVariant,
        choiceKey: choice.key,
        colorLabel: choice.label,
        size: draftSize,
        price: Number(draftVariant.price),
        image: draftVariant.image || imageForChoice(choice, draftSize)
      };

      if (applyAll === true) slots = Array.from({ length: count }, () => ({ ...slots[index] }));
      undoState = null;
      renderSlots(index);
      persist();
      updateSummary({ animate: false });
      resetHint();
      closeModal();
      const nextEmpty = slotsWrap.querySelector('.cl-pack__slot:not(.is-filled)');
      if (nextEmpty) {
        nextEmpty.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        nextEmpty.focus({ preventScroll: true });
      }

      /* Paket bu seçimle tamamlandıysa onay işareti bir kez canlanır. */
      if (!wasComplete && isComplete()) restartAnimation(doneMark, 'is-pop');
    }

    /* ───── Sepet ───── */

    function routesRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function isBusy() {
      return loading || codLoading;
    }

    /* Aynı seçim (varyantlar + adet) tekrar sepete eklenmesin: kapıda ödeme, az önce eklenen paketi yeniden kullanır. */
    function packSignature() {
      return (
        count +
        '|' +
        slots
          .slice(0, count)
          .map(slot => (slot ? slot.variantId : 0))
          .sort((a, b) => a - b)
          .join(',')
      );
    }

    function aggregatedItems(packId) {
      const quantities = new Map();
      slots.slice(0, count).forEach(slot => {
        if (!slot) return;
        quantities.set(slot.variantId, (quantities.get(slot.variantId) || 0) + 1);
      });

      /*
       * Gizli (_ ile başlayan) satır özellikleri müşteriye gösterilmez; sepet/sipariş tarafında paketi
       * tanımak için kullanılır (ör. mağazadaki otomatik indirim). Fiyat bilgisi taşımazlar.
       */
      return [...quantities.entries()].map(([id, quantity]) => ({
        id,
        quantity,
        properties: {
          _cl_pack_key: config.key,
          _cl_pack_size: String(count),
          _cl_pack_id: packId
        }
      }));
    }

    function newPackId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID().slice(0, 8);
      }
      return Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    }

    function emit(name, detail) {
      try {
        document.dispatchEvent(new CustomEvent(name, { detail }));
      } catch (error) {
        /* olay yayınlanamazsa akış etkilenmesin */
      }
    }

    async function readCart(fetchImpl) {
      const response = await fetchImpl(routesRoot() + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Sepet okunamadı (' + response.status + ').');
      return response.json();
    }

    /*
     * Tema ve üçüncü taraf parçaları sepetin değiştiğinden haberdar eder (üst sayaç, tema olayları).
     * Hangi sepet arayüzünün açılacağı openCartUi içinde tek noktadan seçilir.
     */
    function announceCart(cart) {
      if (!cart) return;

      try {
        const itemCount = Number(cart.item_count || 0);

        document.querySelectorAll('[data-cart-count], .cart-count-bubble span:first-child').forEach(element => {
          element.textContent = String(itemCount);
        });

        document.querySelectorAll('cart-count').forEach(element => {
          element.textContent = itemCount > 99 ? '99+' : String(itemCount);
          element.hidden = itemCount === 0;
        });
        document.documentElement.classList.toggle('cart-has-items', itemCount > 0);

        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

        /* Temanın kendi ürün formunun yaptığı gibi: üst sayaç, adet kuralları vb. güncellensin. */
        const fox = window.FoxTheme;
        if (fox && fox.pubsub && fox.pubsub.PUB_SUB_EVENTS && !document.querySelector('cart-items')) {
          fox.pubsub.publish(fox.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart, source: 'craftlabel-pack' });
        }
      } catch (error) {
        console.warn('Craftlabel sepet bildirimi uyarısı:', error);
      }
    }

    /*
     * Sepet arayüzünü TEK bir yerden aç (öncelik sırası):
     *  1) Craftlabel özel sepet çekmecesi  2) UpCart (varsa)  3) temanın eski çekmeceleri
     */
    function openCartUi() {
      const customCart = window.CraftlabelCart;
      if (customCart && typeof customCart.refresh === 'function') {
        customCart.refresh({ open: true, silent: true });
        return 'craftlabel-cart';
      }

      const fox = window.FoxTheme;
      if (fox && fox.utils && typeof fox.utils.isUpCartAvailable === 'function' && fox.utils.isUpCartAvailable()) {
        fox.utils.openUpCartDrawer();
        return 'upcart';
      }

      const drawers = [
        document.querySelector('cart-drawer'),
        document.querySelector('mini-cart'),
        document.querySelector('[data-cart-drawer]')
      ].filter(Boolean);

      for (const drawer of drawers) {
        if (typeof drawer.show === 'function') {
          drawer.show();
          return 'theme-drawer';
        }
        if (typeof drawer.open === 'function') {
          drawer.open();
          return 'theme-drawer';
        }
      }

      return 'none';
    }

    function missingSelectionWarning() {
      const missing = count - filledCount();
      setHint('warning', missing + ' ürün için renk ve beden seçmelisin.');

      const firstEmpty = slotsWrap.querySelector('.cl-pack__slot:not(.is-filled)');
      if (firstEmpty) {
        firstEmpty.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'center'
        });
        firstEmpty.focus({ preventScroll: true });
      }
    }

    /*
     * Paketi sepete ekler (tek istek). quiet=true: özel çekmecenin "sepete eklenince otomatik aç"
     * davranışı (fetch yaması) devre dışı kalsın diye yamasız fetch kullanılır; kapıda ödeme akışı içindir.
     * reuse=true: aynı paket az önce eklendiyse ve hâlâ sepetteyse tekrar eklenmez.
     */
    async function commitPackToCart(options) {
      if (!await window.CraftlabelTestScope.refresh()) throw new Error('Test oturumu değişti. Sayfayı yenileyin.');
      const settings = options || {};
      const pack = currentPack();
      if (!pack || !validCounts.includes(count) || !isComplete()) {
        throw new Error('Geçerli bir paket seçip tüm ürünleri tamamlamalısın.');
      }
      const signature = packSignature();
      const baseFetch = window.fetch.bind(window);
      const rawFetch =
        settings.quiet && typeof window.__clCartOriginalFetch === 'function' ? window.__clCartOriginalFetch : baseFetch;

      if (settings.reuse && lastAdded && lastAdded.signature === signature) {
        const cart = await readCart(rawFetch);
        const lines = (cart.items || []).filter(
          item => item.properties && item.properties._cl_pack_id === lastAdded.packId
        );
        const quantity = lines.reduce((sum, line) => sum + Number(line.quantity || 0), 0);
        if (quantity === count) {
          return { pack, packId: lastAdded.packId, lines, cart, reused: true };
        }
      }

      const packId = newPackId();
      const items = aggregatedItems(packId);
      if (!items.length) throw new Error('Pakette ürün yok.');

      const response = await rawFetch(routesRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });

      let result = null;
      try {
        result = await response.json();
      } catch (parseError) {
        result = null;
      }

      if (!response.ok) {
        const reason = result && (result.description || result.message);
        throw new Error(reason ? 'Sepete eklenemedi: ' + reason : 'Ürünler sepete eklenemedi. Lütfen tekrar dene.');
      }

      lastAdded = { signature, packId };
      return { pack, packId, items, lines: (result && result.items) || [], result, reused: false };
    }

    /* Eklenen satırların gerçek tutarını paket fiyatıyla karşılaştırır; uyuşmazlıkta dürüst not düşer. */
    function reportPricing(commit) {
      if (!moneyVisible || !commit || !commit.pack || commit.reused) return null;

      const pricing = checkCartPricing(commit.lines, commit.pack.total);

      if (pricing.state === 'higher') {
        setNote(
          'Sepetindeki tutar ' + formatTL(pricing.paid) + ' görünüyor. Paket fiyatı (' + formatTL(commit.pack.total) +
            ') sepette henüz uygulanmıyor.'
        );
        console.warn(
          '[Craftlabel Paket] Sepet tutarı paket fiyatıyla uyuşmuyor. Beklenen: ' + commit.pack.total +
            ' kuruş, sepet: ' + pricing.paid + ' kuruş. Mağazadaki paket indirimini kontrol edin.'
        );
      } else if (pricing.state === 'lower') {
        console.warn(
          '[Craftlabel Paket] Sepet tutarı paket fiyatının altında. Beklenen: ' + commit.pack.total +
            ' kuruş, sepet: ' + pricing.paid + ' kuruş.'
        );
      }

      return pricing;
    }

    async function addPackToCart() {
      if (count === 0 || isBusy()) return;

      if (!isComplete()) {
        missingSelectionWarning();
        return;
      }

      loading = true;
      window.clearTimeout(addedTimer);
      isAddedFlash = false;
      setNote('');
      renderAddButton();

      try {
        const commit = await commitPackToCart({ quiet: false });

        /* Başarı yalnızca gerçek sepet sonucundan sonra gösterilir. */
        setHint('success', labels.addedMessage);
        isAddedFlash = true;
        addedTimer = window.setTimeout(() => {
          isAddedFlash = false;
          renderAddButton();
        }, 1800);

        const pricing = reportPricing(commit);

        let cart = null;
        try {
          cart = await readCart(window.fetch.bind(window));
        } catch (readError) {
          console.warn('Craftlabel sepet okunamadı:', readError);
        }
        announceCart(cart);
        const ui = openCartUi();

        emit('craftlabel:pack-added', {
          via: 'cart',
          cartUi: ui,
          packKey: config.key,
          packSize: count,
          packId: commit.packId,
          expectedPackTotal: commit.pack ? commit.pack.total : null,
          pricing: pricing,
          lines: commit.lines,
          cart: cart
        });
      } catch (error) {
        setHint('warning', error.message || 'Ürünler sepete eklenemedi. Lütfen tekrar dene.');
        emit('craftlabel:pack-add-failed', { via: 'cart', packKey: config.key, packSize: count, message: error.message });
      } finally {
        loading = false;
        renderAddButton();
      }
    }

    function waitForReleasit(timeout) {
      return new Promise(resolve => {
        const started = Date.now();

        (function poll() {
          const rsi = window._rsi;
          if (rsi && rsi.form && typeof rsi.form.open === 'function') {
            resolve(true);
            return;
          }
          if (Date.now() - started >= timeout) {
            resolve(false);
            return;
          }
          window.setTimeout(poll, 150);
        })();
      });
    }

    /*
     * Kapıda ödeme: paketin TÜM satırları önce sepete eklenir, sonra Releasit sepet modunda açılır.
     * (Ürün formundan tek varyant gönderen "hemen al" modu paketi taşıyamaz.)
     */
    async function startCodFlow() {
      if (count === 0 || isBusy()) return;

      if (!isComplete()) {
        missingSelectionWarning();
        return;
      }

      codLoading = true;
      setNote('');
      renderAddButton();

      try {
        const commit = await commitPackToCart({ quiet: true, reuse: true });
        const pricing = reportPricing(commit);

        let cart = await readCart(typeof window.__clCartOriginalFetch === 'function' ? window.__clCartOriginalFetch : window.fetch.bind(window));

        /* Özel çekmece hediye/ödül satırlarını eşitlesin (açılmadan); Releasit güncel sepeti görsün. */
        const customCart = window.CraftlabelCart;
        if (customCart && typeof customCart.refresh === 'function') {
          const refreshed = await customCart.refresh({ open: false, silent: true });
          if (refreshed) cart = refreshed;
        }

        announceCart(cart);

        emit('craftlabel:pack-added', {
          via: 'cod',
          packKey: config.key,
          packSize: count,
          packId: commit.packId,
          reused: commit.reused,
          expectedPackTotal: commit.pack ? commit.pack.total : null,
          pricing: pricing,
          lines: commit.lines,
          cart: cart
        });

        /* Releasit yüklenmediyse (ör. taslak temada uygulama gömmesi kapalı) 10 sn bekleyip alert göstermek yerine
           kısa bekle ve paketi sepette bırakarak sepete yönlendir. */
        const codReady = typeof window.CraftlabelOpenCODForm === 'function' && (await waitForReleasit(3000));

        if (codReady) {
          setHint('success', 'Paketin sepete eklendi. Kapıda ödeme formu açılıyor…');
          window.CraftlabelOpenCODForm(null, cart);
        } else {
          setHint('warning', 'Kapıda ödeme formu şu an açılamadı. Paketin sepette; sepetinden devam edebilirsin.');
          openCartUi();
        }
      } catch (error) {
        setHint('warning', error.message || 'Ürünler sepete eklenemedi. Lütfen tekrar dene.');
        emit('craftlabel:pack-add-failed', { via: 'cod', packKey: config.key, packSize: count, message: error.message });
      } finally {
        codLoading = false;
        renderAddButton();
      }
    }

    /*
     * Ürün sayfasındaki sabit "sepete ekle" ve "kapıda ödeme" düğmeleri paket modunda paketi yönetir;
     * tekli modda temanın/uygulamanın kendi akışına dokunulmaz. Sepet çekmecesi ve sepet sayfası hariçtir.
     */
    function handleStickyAdd(event) {
      if (count === 0) {
        if (!event.target.closest?.(CART_UI)) syncSingleQuantity();
        return;
      }

      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const trigger = target.closest('button, a, input[type="submit"], [role="button"], ' + RSI_BUTTON);
      if (!trigger || root.contains(trigger) || modal.contains(trigger) || (bar && bar.contains(trigger))) return;
      if (trigger.closest(CART_UI)) return;

      const text = normalizeText(trigger.value || trigger.textContent);
      const inSticky = Boolean(trigger.closest(STICKY_BAR));
      const isCod = COD_TEXT.test(text) || trigger.matches(RSI_BUTTON);
      const isAdd = /sepete\s*ekle|add\s*to\s*cart/.test(text);

      let handler = null;
      /* Yalnızca satın alma denetimleri: sabit çubuk, Releasit düğmesi veya sepete ekleme formu.
         (Ürün bilgisindeki "Kapıda ödeme nasıl çalışır?" gibi açıklama başlıkları yakalanmaz.) */
      const isPurchaseControl = inSticky || trigger.matches(RSI_BUTTON) || Boolean(trigger.closest('form[action*="/cart/add"]'));
      if (isCod && cod.route && isPurchaseControl) {
        handler = startCodFlow;
      } else if (isAdd && inSticky) {
        handler = addPackToCart;
      }
      if (!handler) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      handler();
    }

    /* ───── Olaylar ───── */

    root.addEventListener('click', event => {
      const card = event.target.closest('.cl-pack__card[data-cl-pack-count]');
      if (card && root.contains(card)) {
        setPackCount(card.dataset.clPackCount);
        return;
      }

      const slot = event.target.closest('.cl-pack__slot[data-slot-index]');
      if (slot && root.contains(slot)) {
        openModal(Number(slot.dataset.slotIndex));
      }
    });

    /* Paket kartları radyo grubudur: oklar seçimi ve odağı birlikte taşır. */
    cardsWrap.addEventListener('keydown', event => {
      const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      if (!(event.key in keys)) return;

      const cards = [...cardsWrap.querySelectorAll('.cl-pack__card[data-cl-pack-count]')];
      const currentIndex = cards.indexOf(document.activeElement);
      if (currentIndex < 0) return;

      event.preventDefault();
      const target = cards[(currentIndex + keys[event.key] + cards.length) % cards.length];
      target.focus();
      setPackCount(target.dataset.clPackCount);
    });

    upsellButton.addEventListener('click', () => {
      const target = Number(upsellButton.dataset.target);
      if (target) setPackCount(target);
    });

    singleLink.addEventListener('click', () => setPackCount(0));
    function primaryAction() {
      if (isBusy()) return;
      if (isComplete()) return addPackToCart();
      const index = slots.findIndex(slot => !slot);
      if (index >= 0) openModal(index);
    }
    addButton.addEventListener('click', primaryAction);
    if (codButton) codButton.addEventListener('click', startCodFlow);
    if (barAdd) barAdd.addEventListener('click', primaryAction);
    if (barCod) barCod.addEventListener('click', startCodFlow);

    /* Gövdedeki "Paketi sepete ekle" görünürdeyken sabit çubuk gizlenir (iki aynı düğme üst üste durmasın). */
    if (bar && barConfig.enabled && 'IntersectionObserver' in window) {
      barObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            inlineCtaVisible = entry.isIntersecting;
          });
          renderBarState();
        },
        { threshold: [0, 0.01, 1] }
      );
      barObserver.observe(root.querySelector('[data-cl-pack-summary]'));
    }
    window.addEventListener('resize', measureBar);
    window.addEventListener('scroll', scheduleWhatsapp, { passive: true });
    saveButton.addEventListener('click', () => saveSlot());
    applyButton.addEventListener('click', () => saveSlot(true));
    removeButton.addEventListener('click', () => {
      if (activeSlotIndex < 0 || activeSlotIndex >= count) return;
      slots[activeSlotIndex] = null;
      undoState = null;
      renderSlots(-1);
      persist();
      updateSummary({ animate: false });
      resetHint();
      closeModal();
    });
    document.addEventListener('variant:changed', syncSinglePrice);
    document.addEventListener('change', handleNativeChange);
    document.addEventListener('formdata', handleSingleFormData, true);
    modal.querySelectorAll('[data-cl-pack-close]').forEach(button => button.addEventListener('click', closeModal));
    document.addEventListener('click', handleStickyAdd, true);

    function handleKeydown(event) {
      if (modal.hidden) return;

      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      if (event.key === 'Tab') {
        const focusable = focusableInModal();
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    function cleanupInstance() {
      document.removeEventListener('click', handleStickyAdd, true);
      document.removeEventListener('variant:changed', syncSinglePrice);
      document.removeEventListener('change', handleNativeChange);
      document.removeEventListener('formdata', handleSingleFormData, true);
      document.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);
      window.clearTimeout(addedTimer);

      if (modal && modal.isConnected) modal.remove();

      document.body.classList.remove('cl-pack-modal-open');
      if (barObserver) barObserver.disconnect();
      window.removeEventListener('resize', measureBar);
      window.removeEventListener('scroll', scheduleWhatsapp);
      window.cancelAnimationFrame(whatsappFrame);
      document.documentElement.style.removeProperty('--cl-pack-wa-lift');
      delete document.documentElement.dataset.clPackWaHidden;
      if (bar && bar.isConnected) bar.remove();
      document.documentElement.dataset.clPackBar = 'off';
      document.documentElement.style.removeProperty('--cl-pack-bar-h');
      restoreNativePurchaseControls();

      if (instanceRegistry[root.id] === cleanupInstance) delete instanceRegistry[root.id];
    }

    function handleSectionUnload(event) {
      if (String(event.detail && event.detail.sectionId) !== String(root.dataset.sectionId)) return;
      cleanupInstance();
    }

    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('shopify:section:unload', handleSectionUnload);
    instanceRegistry[root.id] = cleanupInstance;

    /* ───── Başlangıç ───── */

    buildColorChoices();

    /* Renk değişiminde (AJAX ürün yenilemesi) önceki seçimleri koru. */
    if (count > 0) {
      slots = Array.from({ length: count }, (_, index) => stashedSlots[index] || null);
    } else {
      parkedSlots = stashedSlots.slice();
    }

    setPackCount(count, { initial: true });

    /*
     * Tema bazı satın alma düğmelerini gecikmeli oluşturabildiği için
     * seçili moda göre görünürlüğü bir kez daha eşitle.
     */
    window.requestAnimationFrame(syncPurchaseMode);
    window.setTimeout(syncPurchaseMode, 400);
    loadLinkedColorProducts();
  }

  function initializeRoots(scope) {
    if (!scope) return;

    if (scope.nodeType === 1 && scope.matches && scope.matches('[id^="CraftlabelCustomPack-"]')) {
      initCraftlabelCustomPack(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('[id^="CraftlabelCustomPack-"]').forEach(initCraftlabelCustomPack);
    }
  }

  /*
   * Taslak tema önizlemesinde konsoldan çalıştırılır: CraftlabelPack.debug()
   * Sepet çekmecesi, Releasit, UpCart ve sabit çubuktaki "kapıda ödeme" düğmelerinin tespitini raporlar.
   */
  function debugEnvironment() {
    const label = element => ({
      tag: element.tagName.toLowerCase(),
      text: String(element.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 40),
      id: element.id || '',
      class: String(element.className || '').slice(0, 90),
      inCartUi: Boolean(element.closest(CART_UI)),
      detectedAsCod: COD_TEXT.test(String(element.textContent || '').trim().toLocaleLowerCase('tr-TR')) || element.matches(RSI_BUTTON)
    });

    const candidates = [
      ...document.querySelectorAll(
        STICKY_BAR.split(',').map(selector => selector.trim() + ' button').join(', ') +
          ', [class*="_rsi"], [id*="_rsi"], [data-rsi-buy-now], form[action*="/cart/add"] button'
      )
    ].map(label);

    const rsi = window._rsi || null;
    const fox = window.FoxTheme;

    return {
      packRoots: document.querySelectorAll('[id^="CraftlabelCustomPack-"]').length,
      customCart: {
        api: Boolean(window.CraftlabelCart),
        fetchPatched: Boolean(window.__clCartFetchPatched),
        originalFetch: typeof window.__clCartOriginalFetch
      },
      releasit: {
        rsi: Boolean(rsi),
        form: Boolean(rsi && rsi.form),
        open: Boolean(rsi && rsi.form && typeof rsi.form.open === 'function'),
        mode: rsi && rsi.form ? rsi.form.mode : null,
        codOpener: typeof window.CraftlabelOpenCODForm
      },
      upcart: {
        available: Boolean(fox && fox.utils && fox.utils.isUpCartAvailable && fox.utils.isUpCartAvailable()),
        globals: ['UpCart', 'Upcart', 'upcartOpen', 'UpcartOpen', 'openUpcart'].filter(name => window[name])
      },
      foxTheme: Boolean(fox && fox.pubsub),
      html: {
        mode: document.documentElement.dataset.clPackMode,
        bar: document.documentElement.dataset.clPackBar
      },
      productPageButtons: candidates
    };
  }

  window.CraftlabelPack = {
    loaded: true,
    Pure: Pure,
    scan: initializeRoots,
    debug: debugEnvironment
  };

  initializeRoots(document);

  /*
   * Renk swatch'ına basılınca tema ürün bilgisini AJAX ile yeniliyor. innerHTML ile gelen scriptler
   * yeniden çalışmadığı için bu gözlemci yeni gelen paket bloğunu otomatik başlatır.
   */
  if (!window.__craftlabelCustomPackObserver) {
    window.__craftlabelCustomPackObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          initializeRoots(node);
        });
      });
    });

    window.__craftlabelCustomPackObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
